import React from 'react';
import { Button, Checkbox } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import './PromptEditor.css';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default function PromptAssistReviewBar({
  visible,
  highlightDiff,
  onHighlightDiffChange,
  onDiscard,
  onTryAgain,
  onAccept,
  canAccept,
  loading,
}) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="assist-review-bar"
          className="prompt-assist-review-bar"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: prefersReducedMotion() ? 0 : 0.15 }}
        >
          <Checkbox
            checked={highlightDiff}
            onChange={(e) => onHighlightDiffChange(e.target.checked)}
            className="prompt-assist-review-checkbox"
          >
            Highlight differences
          </Checkbox>
          <div className="prompt-assist-review-bar-buttons">
            <Button type="text" size="small" onClick={onDiscard} disabled={loading}>
              Discard
            </Button>
            <Button size="small" onClick={onTryAgain} loading={loading}>
              Try again
            </Button>
            <Button type="primary" size="small" onClick={onAccept} disabled={!canAccept || loading}>
              Accept
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
